// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Clock_buttonsContainer__QNENk","clock":"Clock_clock__n3Hgt","watch":"Clock_watch__qNIRa","more":"Clock_more__fw-r5"};